import {Button, Table} from "antd";
import React from "react";
import {SwapOutlined} from "@ant-design/icons";
import SportBetLogTable from "../../sport/component/table";
import BigNumber from "bignumber.js";

const {Column} = Table;

type Props = {
  loading: boolean,
  data: any[],
}

const FishingBetLogTable = ({loading, data}: Props) => {
  return (<Table
    className="mt-4"
    rowKey='id' size="small" bordered loading={loading} dataSource={data}
    pagination={false}>
    <Column title="No." align='center' render={(_text, _record, index) => index + 1}/>
    <Column title="B.ID" align='center' dataIndex='bet_id' key='bet_id'/>
    <Column title="Username"  render={(_, record: any) => (
      <div className='ml-2 text-red-600 cursor-pointer underline' >{record.user?.username?.toUpperCase()}</div>
    )}/>

    <Column title="Status"  render={(_, record: any) => {
      if(record.is_hold == 0) {
        return <div>Complete
          <span className='ml-2 text-xs text-red-600 cursor-pointer' >
            ({record.return_balance_count} <SwapOutlined/>)
          </span>
        </div>
      }
      return <div>Playing</div>
    }}/>
    <Column title="In.Amount" dataIndex='amount' key='amount' align='right'
            render={text => <span>{BigNumber(text).dividedBy(100).toFixed(2)}</span>}/>

    <Column title="Re.Amount" dataIndex='return_amount' key='return_amount' align='right'
            render={text => <span>{BigNumber(text).dividedBy(100).toFixed(2)}</span>}/>

    <Column title="W/L Coin" dataIndex='amount' key='amount' align='right'
            render={(_, record: any) =>{
              if(record.is_hold == 1) {
                return <div>???</div>
              }
              const totalAmount = BigNumber(record.return_amount).minus(record.amount).dividedBy(100)
              return (<span className={totalAmount.toNumber() > 0 ? 'text-green-600' : totalAmount.toNumber() == 0 ? 'text-black-600' : 'text-red-600'}>
                {totalAmount.toFormat(2)}
              </span>)
            }}/>

    <Column title="In.Amount Riel" dataIndex='amount_riel' key='amount_riel' align='right'
            render={text => <span>{Number(text).toLocaleString()}</span>}/>

    <Column title="Re.Amount Riel" dataIndex='return_amount_riel' key='return_amount_riel' align='right'
            render={text => <span>{Number(text).toLocaleString()}</span>}/>

    <Column title="W/L Riel" dataIndex='amount' key='amount' align='right'
            render={(_, record: any) =>{
              if(record.is_hold == 1) {
                return <div>???</div>
              }
              const totalAmount = BigNumber(record.return_amount_riel).minus(record.amount_riel)
              return (<span className={totalAmount.toNumber() > 0 ? 'text-green-600' : totalAmount.toNumber() == 0 ? 'text-black-600' : 'text-red-600'}>
                {totalAmount.toFormat()}
              </span>)
            }}/>
  </Table>)
}

export default FishingBetLogTable